import React from "react";
import './Contact.scss';
import lang from '../../i18/lang';
import axios from "axios";
import {BAM_API_SEND_MESSAGE} from "../../const/api";
import Notification from "../notification/Notification";
import left_comment from "../../assets/illustration/left-comment.png";
import right_comment from "../../assets/illustration/right-comment.png";
import phone from "../../assets/icons/phone.png";
import email from "../../assets/icons/email.png";

class Contact extends React.Component {

    state = {
        name: '',
        contact: '',
        text: '',
        notification: {
            open: false,
            isSuccessful: true
        }
    };

    onChange = (e, fieldName) => {
        this.setState({
            [fieldName]: e.target.value
        });
    };

    sendMessage = () => {
        axios.post(BAM_API_SEND_MESSAGE, {
            name: this.state.name,
            contact: this.state.contact,
            text: this.state.text
        })
            .then(this.handleSuccessfulMsg)
            .catch(this.handleFailedMsg);
    };

    handleSuccessfulMsg = () => {
        this.setState({
            notification: {
                open: true,
                isSuccessful: true
            }
        })
    };

    handleFailedMsg = () => {
        this.setState({notification: {
                open: true,
                isSuccessful: false
            }})
    };

    closeNotification = () => {
        this.setState({
            notification: {
                open: false,
                isSuccessful: true
            }
        })
    };

    render(){
        return (
          <div>
              <div className="contact-wrapper">
                  <div className="contact-title">
                      <h1>{lang.srb.section.contact.naslov}</h1>
                  </div>
                  <div className="contact-form">
                      <div style={{margin: "20px"}}>
                          <p id="form-title">{lang.srb.section.contact.posaljite_nam_poruku}</p>
                          <p>{lang.srb.section.contact.ime_i_prezime}</p>
                          <input type="text" value={this.state.name} onChange={(e) => this.onChange(e, 'name')}/>
                          <p>{lang.srb.section.contact.kontakt}</p>
                          <input type="text" value={this.state.contact} onChange={(e) => this.onChange(e, 'contact')}/>
                          <p>{lang.srb.section.contact.poruka}</p>
                          <textarea rows="10" value={this.state.text} onChange={(e) => this.onChange(e, 'text')}></textarea>
                          <button onClick={this.sendMessage}>{lang.srb.section.contact.posalji}</button>
                      </div>
                  </div>
                  <div className="slope-div bg-black"></div>
                  <div className="contact-footer">
                      <div className="contact-footer-content">
                          <div className="contact-footer-left">
                              <div className="left-content info">
                                  <a href={`tel:${lang.srb.telefon_1}`}>
                                      <img src={left_comment} alt=""/>
                                      <div className="over-icon-content">
                                          <img className="contact-icon" src={phone} alt=""/>
                                          <h3>{lang.srb.section.contact.pozovite_nas}</h3>
                                          <p>{lang.srb.telefon_1}</p>
                                      </div>
                                  </a>
                              </div>
                          </div>
                          <div className="contact-footer-right">
                              <div className="right-content info">
                                  <a  href={`mailto:${lang.srb.mejl}`}>
                                      <img src={right_comment} alt=""/>
                                      <div className="over-icon-content">
                                          <img className="contact-icon" src={email} alt=""/>
                                          <h3>{lang.srb.section.contact.posaljite_mejl}</h3>
                                          <p>{lang.srb.mejl}</p>
                                      </div>
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <Notification open={this.state.notification.open}
                            isSuccessful={this.state.notification.isSuccessful}
                            onClose={this.closeNotification}/>
          </div>

    )
    }
}

export default Contact;